var CommonHelpers = (function () {
    function CommonHelpers() {
    }
    CommonHelpers.getIdentifier = function (id, config) {
        var schemaID = config === null || config === void 0 ? void 0 : config.schemaID;
        if (schemaID) {
            return "".concat(schemaID, "-").concat(id);
        }
        return id;
    };
    return CommonHelpers;
}());
export { CommonHelpers };
//# sourceMappingURL=common.js.map